import { render, staticRenderFns } from "./opendialog.vue?vue&type=template&id=97d7784e"
import script from "./opendialog.vue?vue&type=script&lang=js"
export * from "./opendialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports